import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css"; // Import CSS for AOS animations
import Frame3 from "/Images/Frame 3 (1).svg"; // Import the Frame 3 image
import CustodyIcon1 from "/Images/custodyicon1.svg";
import CustodyIcon2 from "/Images/custodyicon2.svg";
import CustodyIcon3 from "/Images/custodyicon3.svg";
import CustodyIcon4 from "/Images/custodyicon4.svg";
import CustodyIcon5 from "/Images/custodyicon5.svg";
import CustodyIcon6 from "/Images/custodyicon6.svg";
import { useMediaQuery } from "@mui/material";

const Platform = () => {
  useEffect(() => {
    AOS.init({ duration: 600, once: true }); // Initialize AOS with animation duration and make it play only once
  }, []);

  const isMobile = useMediaQuery("(max-width: 767px)"); // Media query untuk cek layar mobile

  const platforms = [
    {
      iconSrc: CustodyIcon1,
      title: "Safekeeping",
      text: "Custody any digital asset on premise and in the cloud",
      delay: "50",
    },
    {
      iconSrc: CustodyIcon2,
      title: "Asset servicing",
      text: "Automate custody and asset servicing for tokenized securities",
      delay: "50",
    },
    {
      iconSrc: CustodyIcon3,
      title: "Staking / Baking",
      text: "Generate passive yields on last generation blockchains",
      delay: "50",
    },
    {
      iconSrc: CustodyIcon4,
      title: "DeFi",
      text: "Automate interactions with all largest DeFi protocols: Lend-Deposit-Borrow-Swap",
      delay: "200",
    },
    {
      iconSrc: CustodyIcon5,
      title: "Manage Transaction",
      text: "Save time and costs by validating transactions in batch",
      delay: "200",
    },
    {
      iconSrc: CustodyIcon6,
      title: "Risk management",
      text: "All banking-grade risk controls embedded and automated",
      delay: "200",
    },
  ];

  return (
    <section
      style={{
        background:
          "radial-gradient(circle at center top, #0582CA 0%, #0972B0 13%, #0E6197 21%, #0D527E 27%, #134264 37%, #16324A 100%)",
        paddingTop: isMobile ? "2rem" : "4rem",
        padding: isMobile ? "2rem" : "4rem 5rem",
        paddingBottom: isMobile ? "4rem" : "6.5rem",
        position: "relative",
        fontFamily: "Poppins",
      }}
    >
      <div
        style={{
          maxWidth: "1290px",
          margin: "0 auto",
          padding: isMobile ? "0 10px" : "0 20px",
          textAlign: "center",
        }}
      >
        {/* Title Section */}
        <div style={{ marginBottom: "20px" }}>
          <h2
            style={{
              fontSize: isMobile ? "1.8rem" : "2.5rem", // Smaller font size on mobile
              fontWeight: "bold",
              background: "linear-gradient(90deg, #FFFFFF 0%, #ACD5ED 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
              color: "transparent",
              maxWidth: isMobile ? "90%" : "770px", // Responsive width adjustment
              margin: "0 auto", // Center the text
              textAlign: "center", // Center alignment on mobile and desktop
            }}
          >
            Unlock the Answers to All Your Needs Faster, Easier and Secure
          </h2>
        </div>

        {/* Card Section */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: isMobile ? "10px" : "20px",
          }}
        >
          {platforms.map((platform, index) => (
            <div
              key={index}
              data-aos="fade-up"
              data-aos-delay={platform.delay}
              style={{
                width: isMobile ? "100%" : "390px", // Full width on mobile
                height: isMobile ? "auto" : "180px",
                position: "relative",
                display: "flex",
                flexDirection: isMobile ? "column" : "row", // Column layout on mobile
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
                padding: isMobile ? "20px" : "0",
                margin: "0",
              }}
            >
              {/* Background Image */}
              <img
                src={Frame3}
                alt="Frame background"
                style={{
                  position: "absolute",
                  top: "0",
                  left: "0",
                  width: "100%",
                  height: "100%",
                  zIndex: -1,
                  objectFit: "fill",
                }}
              />

              {/* Content inside the frame */}
              <div
                style={{
                  display: "flex",
                  flexDirection:  "row", // Column layout on mobile, row on desktop
                  alignItems: "center",
                  gap: isMobile ? "10px" : "15px",
                  zIndex: 1,
                  textAlign:   "left", // Center align on mobile, left on desktop
                  padding: isMobile ? "20px" : "40px",
                  paddingBottom: isMobile ? "10px" : "20px",
                }}
              >
                <img
                  src={platform.iconSrc}
                  alt={platform.title}
                  style={{
                    width: isMobile ? "50px" : "40px",
                    height: isMobile ? "50px" : "40px",
                    marginBottom: isMobile ? "10px" : "0",
                    marginRight: isMobile ? "8px" : "5px",
                    alignSelf: isMobile ? "center" : "flex-start", // Center on mobile, top on desktop
                  }}
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    width: isMobile ? "90%" : "auto",
                  }}
                >
                  <h3
                    style={{
                      color: "#F4E37B",
                      fontSize: isMobile ? "16px" : "20px",
                      fontWeight: "600",
                      margin: 0,
                    }}
                  >
                    {platform.title}
                  </h3>
                  <p
                    style={{
                      color: "#FFFFFF",
                      fontSize: isMobile ? "0.875rem" : "1rem",
                      lineHeight: "1.4",
                      marginTop: "5px",
                    }}
                  >
                    {platform.text}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Platform;
